import { render, staticRenderFns } from "./PasswordStrategy.vue?vue&type=template&id=3573597a&"
import script from "./PasswordStrategy.vue?vue&type=script&lang=js&"
export * from "./PasswordStrategy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports